<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                대외기관과의 협력 및 고객 지원을<br />
                담당하는 <strong class="c-red">카드 업무실</strong>
            </h1>
            <p>
                카드업무실은 각 카드사 및 관련 기관과의 협력 업무를 수행하는 카드업무팀과 대리점 및 가맹점 지원 업무를 담당하는 영업지원팀으로
                이루어져 있습니다.<br />
                카드업무팀은 제휴서비스 개발, 유관기관과의 대외업무 등을 수행함으로써 대외기관과의 긴밀한 협력관계를 유지합니다.<br />
                고객지원을 담당하는 영업지원팀은 대리점 및 가맹점 업무용 전산시스템 운영, 고객만족 실현을 위한 서비스 기획 업무를 수행하고
                있습니다.<br class="pc-only" />
                고객을 먼저 생각하는 한국정보통신 카드업무실에서는 능동적이고 창의적인 인재를 기다립니다.
            </p>
            <img src="@/assets/card_image01.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>